import actions from '../../actionTypes';

export default area => {
  return {
    type: actions.ADDED_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/areaAdded.js